import axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function SelectAddress({ mobile, selectedAddress }) {
    const [address, setAddress] = useState([]);
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    const handleUserData = async () => {
        try {
            const response = await axios.get(`${API_URL}/user-address/${mobile}`);
            setAddress(response.data.address || []);
        } catch (err) {
            console.error("Error fetching user address:", err);
        }
    };

    useEffect(() => {
        handleUserData();
    }, [mobile]);

    return (
        <Fragment>
            <div className="modal fade vertically-center" id="addressmodal" tabIndex="-1" aria-labelledby="addressModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addressModalLabel">Select Delivery Address</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <button className='w-100 btn-sm select-add-btn' onClick={() => navigate('/add-address')} data-bs-dismiss="modal">ADD NEW ADDRESS</button>
                            {address.length > 0 ? (
                                address.map((item, index) => {
                                    const key = item._id || item.id || index;
                                    return (
                                        <div key={key} className="address-card-redesigned" tabIndex={0}>
                                            <div className="addr-head">
                                                <span className="addr-name">{item.name}</span>
                                                {index === 0 && <span className="addr-default">DEFAULT</span>}
                                            </div>
                                            <div className="addr-lines">
                                                <span>{item.house}, {item.area}, {item.city}</span>
                                                {item.landmark && <span className="addr-landmark"> (Landmark: {item.landmark})</span>}
                                            </div>
                                            <div className="addr-phone">📞 {item.mobile}</div>
                                            <div className="addr-actions">
                                                <button className="addr-select" data-bs-dismiss="modal" onClick={() => selectedAddress(item)}>DELIVER HERE</button>
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <p className="text-center">No saved addresses found.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default SelectAddress;
